import { useQuery } from "@tanstack/react-query";
import { fetchBelege } from "./belege";

/**
 * Rechnungen mit offener Preisprüfung – dieselbe Zahl in Menü, Übersicht und
 * auf der Seite Rechnungsprüfung (Reiter „Zu prüfen“), #630.
 */
export function useOpenInvoiceCount(enabled: boolean) {
  const query = useQuery({
    queryKey: ["belege", "rechnungspruefung", "open-count"],
    queryFn: () => fetchBelege({ limit: 1, docType: "rechnung" }),
    enabled,
    staleTime: 60_000,
  });
  return { ...query, count: query.data?.workflow_status_counts?.open ?? 0 };
}
